export const ROUTES = {
  WHITEBOARD_PAGE: buildRoute(""),
  LOGIN_PAGE: buildRoute("login"),
  DM_PAGE: buildRoute("dm"),
  FRIEND_PAGE: buildRoute("friend"),
  B_TO_C_PAGE: buildRoute("b-to-c"),
  SMALL_APPS_PAGE: buildRoute("small-apps"),
  KEYPAIR_PAGE: buildRoute("key"),
  REDIRECT_PAGE: buildRoute("redirect"),
  STATIC_HOME_PAGE: buildRoute("static/protico"),
};
function buildRoute(path: string) {
  return "/" + path;
}
